/**
 * @fileoverview SettingsSidebarFooter — bottom-pinned section inside the
 * SettingsSidebar (AIP, Help, Open Foundry, user). Same SettingsSidebarLink
 * rows as the main sidebar, just pinned to the bottom.
 *
 * Foundry mapping: `control-panel-shell__sidebar-footer-section`. Equivalent
 * to <SettingsSidebarSection footer> — provided as a separate component
 * because the Foundry HTML and the vocabulary treat it as a distinct slot.
 */

import type { ReactNode } from "react";
import { SettingsSidebarSection } from "./settings-sidebar-section";

interface SettingsSidebarFooterProps {
  children: ReactNode;
  className?: string;
}

export function SettingsSidebarFooter({ children, className }: SettingsSidebarFooterProps) {
  return (
    <SettingsSidebarSection data-testid="settings-sidebar-footer" footer className={className}>
      {children}
    </SettingsSidebarSection>
  );
}
